const contact = {
  title: {
    vi: "Liên hệ",
    en: "Contact us",
  },
  paragraph: {
    vi: `
            <p>
                Estuary sẽ phân tích tình hình và các vấn đề của doanh nghiệp bạn;
                <br/>từ đó đề xuất và phát triển các giải pháp phù hợp theo nhu cầu cụ thể của công ty bạn.
            </p>
            <p class="mt-3">Điền mẫu thông tin hoặc <a href="tel: ${process.env.NEXT_PUBLIC_HOTLINE}" className="cursor-pointer text-dark-blue">gọi cho chúng tôi</a> để được tư vấn ngay!</p>
        `,
    en: `
            <p>
                Estuary listens to enterprise’s brief, contribute to bring clarity on business issues, 
                <br/>propose concepts and develop them according to your specific needs.
            </p>
            <p>
                Fill out the form or <a href="tel: ${process.env.NEXT_PUBLIC_HOTLINE}" className="cursor-pointer text-dark-blue">call us</a> for a consultancy!
            </p>
        `,
  },
  email: {
    vi: `info@estuary.solutions`,
    en: `info@estuary.solutions`,
  },
  phone: {
    vi: process.env.NEXT_PUBLIC_HOTLINE,
    en: process.env.NEXT_PUBLIC_HOTLINE,
  },
  form_name: {
    vi: `Họ và Tên *`,
    en: `Full name *`,
  },
  form_phone: {
    vi: `Số điện thoại *`,
    en: `Phone number *`,
  },
  form_email: {
    vi: `Email *`,
    en: `Email *`,
  },
  form_company: {
    vi: `Tên công ty`,
    en: `Company`,
  },
  form_message: {
    vi: `Ý kiến của bạn`,
    en: `Your message`,
  },
  send: {
    vi: `Gửi ngay`,
    en: `Send`,
  },
};

export default contact;
